export default __webpack_public_path__ + "static/media/redo.15484379.svg";